export default __webpack_public_path__ + "static/media/site.b840e5d6.png";